import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`grid items-start md:grid-cols-2 gap-x-16 gap-y-8`};
`

export const Title = styled.div``

export const Description = styled.div``

export const Main = styled.div``
